import { render, staticRenderFns } from "./AdminElement.vue?vue&type=template&id=615fa6f4&scoped=true&"
import script from "./AdminElement.vue?vue&type=script&lang=ts&"
export * from "./AdminElement.vue?vue&type=script&lang=ts&"
import style0 from "./AdminElement.vue?vue&type=style&index=0&id=615fa6f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615fa6f4",
  null
  
)

export default component.exports